import { RouteConfig } from 'vue-router';

import { ModuleName } from '@/enums/moduleName.enum';
import { Options } from '@/enums/options.enum';
import { PublicSettings } from '@/enums/publicSettings.enum';
import { TableName } from '@/enums/tableName';
import store from '@/store/store';
import Errors from '@/views/mainRoute/document/details/Errors.vue';

export const documentErrorsRoute: RouteConfig = {
  path: 'errors',
  name: 'documentErrors',
  component: Errors,
  beforeEnter: (to, from, next) => {
    store.commit('document/setId', parseInt(to.params.documentId));
    store.commit('documentIndex/setId', parseInt(to.params.documentId));
    Promise.all([
      store.dispatch('documentIndex/get'),
      store.dispatch('document/get'),
      store.dispatch('setting/findPublic', { code: PublicSettings.OW_003_RANGES })
    ])
      .then(([documentIndex, document]) => {
        const ids = [...(documentIndex.previousStatuses || []), documentIndex.statusId];
        return Promise.all([
          store
            .dispatch('document/status/list', { ids, module: ModuleName.edit })
            .then(statuses => {
              if (statuses.list.some((status: any) => status.id === documentIndex.statusId)) {
                return documentIndex.statusId;
              }
              return ids.reverse().find(id => statuses.list.some((status: any) => status.id === id));
            })
            .then(statusId =>
              store.dispatch('optionValue/getByCode', {
                code: Options.SCHEMA_ID,
                entityType: TableName.status,
                entityId: statusId.toString()
              })
            )
            .then(optionValue => store.dispatch('schema/get', parseInt(optionValue.value))),
          store.dispatch('optionValue/getByCode', {
            code: Options.TERM_PASSED,
            entityType: TableName.status,
            entityId: document.procedure.status.id.toString()
          })
        ]);
      })
      .then(() => next());
  }
};
